import request from "@/utils/request";
import Axios from "axios";

class UploadOSSUtil {
  // 获取签字
  _getSignature(file) {
    return new Promise((resolve, reject) => {
      request({
        url: "/api/SystemMethod/GetPolicyAsync",
        method: "post",
        data: { fileName: file.name }
      })
        .then(res => {
          resolve(JSON.parse(res.Data));
        })
        .catch(e => {
          reject(e);
        });
    });
  }
  // 上传到OSS
  uploadOSS(file) {
    return new Promise((resolve, reject) => {
      this._getSignature(file).then(sign => {
        const param = new FormData();
        param.append("key", sign.key);
        param.append("policy", sign.policy);
        param.append("OSSAccessKeyId", sign.OSSAccessKeyId);
        param.append("success_action_status", "200");
        param.append("callback", sign.callback);
        param.append("signature", sign.signature);
        param.append("x-oss-content-type", "application/octet-stream");
        param.append("file", file);
        Axios({
          url: sign.Host,
          method: "post",
          data: param,
          config: {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        })
          .then(res => {
            console.log(sign);
            resolve({
              Code: 0,
              Data: { ID: sign.key },
              Msg: "上传成功"
            });
          })
          .catch(e => {
            reject(e);
          });
      }).catch(e=>{
        reject(e)
      });
    });
  }
}
export default new UploadOSSUtil();



// WEBPACK FOOTER //
// ./src/utils/uploadOSS.js